/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './SubScopeofServicesComponent.module.scss';
import metadata from './SubScopeofServicesComponent.metadata.json5';

function SubScopeofServicesComponent(props) {

    const {
        data: ScopeofServicesVM,
        updateWizardData,
        submissionVM,
        ScopeofServicesPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    
    ScopeofServicesVM.value.isValidationReq = true


    const addScopeofServices = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ScopeofServicesVM.value = ScopeofServicesVM.value || []

            const { _xCenter, _dtoName } = ScopeofServicesVM;

            const ScopeofServicesObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ScopeofServicesVM.pushElement(
                ScopeofServicesObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ScopeofServicesVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ScopeofServicesVM.value.splice(index, 1);
            _.set(submissionVM.value, ScopeofServicesPath, ScopeofServicesVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ScopeofServicesPath, ScopeofServicesVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;


            if (path === 'perOfRev2') {
                const value = item.perOfRev2 ? item.perOfRev2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des3') {
                const value = item.des3 ? item.des3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'proAndSer1') {
                const value = (item && item.proAndSer1) ? item.proAndSer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ScopeofServicesVM.length > 0 && ScopeofServicesVM.children[index].proAndSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? ScopeofServicesVM.children[index].proAndSer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.proAndSer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'claTyp4') {
                const value = (item && item.claTyp4) ? item.claTyp4 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ScopeofServicesVM.length > 0 && ScopeofServicesVM.children[index].proAndSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? ScopeofServicesVM.children[index].claTyp4.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.claTyp4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }


        }, [ScopeofServicesVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ScopeofServicesTable`]: {
            data: ScopeofServicesVM.value,
        },
        [`claTyp4Header`]: {
            visible: false
        }

    }), [ScopeofServicesVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addScopeofServices,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ScopeofServicesVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ScopeofServicesVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ScopeofServicesVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubScopeofServicesComponent.propTypes = wizardProps;
export default withRouter(SubScopeofServicesComponent);
